import { AxiosInstance } from "../../../axios/axiosInstance";
import { apiRoutes } from "../../../utils/ApiRoutes";

export interface IUpdateOnboardingStepPayload {
  step: string;
  status: string;
  selected_business_id?: string;
}

export interface IGetAddonDetailsPayload {
  addon_id: string;
}

export interface ICreateNativeSubscriptionPayload {
  business_id: string;
  type?: string;
  billingDetailsCollectionConfiguration?: {
    name?: string;
    email?: string;
  };
}

export const getOnboardingStateApi = () => {
  return AxiosInstance.get("/workspace/onboarding-state");
};

export const updateOnboardingStateApi = (
  data: IUpdateOnboardingStepPayload,
) => {
  return AxiosInstance.post("/workspace/onboarding-state", data);
};

export const getAddonDetailsApi = (data: IGetAddonDetailsPayload) => {
  return AxiosInstance.post(apiRoutes.addonDetails, data);
};

export const createNativeSubscriptionApi = (
  data: ICreateNativeSubscriptionPayload,
) => {
  return AxiosInstance.post(apiRoutes.createNativeSubscription, data);
};
